import { Component, type ReactNode } from 'react';

export class ErrorBoundary extends Component<{ children: ReactNode }, { error?: Error }> {
  state: { error?: Error } = {};

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    const err = this.state.error;
    if (!err) return this.props.children;
    return (
      <div className="dot-grid flex h-screen items-center justify-center p-6">
        <div className="w-full max-w-md rounded-2xl border bd surface p-6 text-center">
          <div className="text-lg font-semibold">Something broke</div>
          <p className="mt-1 text-xs text-muted">show this to your coding agent to fix it</p>
          <div className="mt-3 rounded-lg border border-red-400/30 bg-red-400/10 p-3 text-left text-sm font-medium text-red-200">
            {err.name}: {err.message || '(no message)'}
          </div>
          <pre className="mt-2 max-h-56 overflow-auto whitespace-pre-wrap break-words text-left text-[11px] leading-relaxed text-red-300/80">
            {String(err.stack || err)}
          </pre>
          <button
            onClick={() => location.reload()}
            className="mt-4 rounded-lg border bd px-4 py-2 text-sm transition hover:bd-strong hover:text-fg"
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}
